<template>
  <div>
    <el-container>
      <el-header height="60px" class="homeHeader">
        <div class="leftMsg">
          <!--              Logo-->
                    <img class="logoImg" src="../../assets/logo.png"/>
          <div class="title">
            <div class="sysName">TallTalk</div>
          </div>
        </div>
        <el-dropdown class="userInfo" @command="commandHandler">
  <span class="el-dropdown-link">
    {{ user.username }}
<!--    <el-avatar size="medium" :src="user.avatarUrl"></el-avatar>-->
    <i class="el-icon-arrow-down el-icon--right"></i>
  </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userInfo">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout">注销登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-container>
        <el-aside width="200px" style="height: 100%">
          <el-menu router
                   text-color="#909399"
                   unique-opened="true"
                   class="el-menu-vertical-demo">
<!--            <el-menu-item index="/home">-->
<!--              <i class="el-icon-folder"></i>-->
<!--              <span slot="title">我的文件</span>-->
<!--            </el-menu-item>-->
<!--            <el-menu-item index="/teacherFolders">-->
<!--              <i class="el-icon-folder-opened"></i>-->
<!--              <span slot="title">教师文件</span>-->
<!--            </el-menu-item>-->
<!--            <el-menu-item index="/teacherVideo">-->
<!--              <i class="el-icon-video-camera"></i>-->
<!--              <span slot="title">教学视频</span>-->
<!--            </el-menu-item>-->
            <template v-for="(item,index) in routes">
              <el-submenu :index="index+''" :key="index+''" v-if="!item.hidden">
                <template slot="title"><i :class="item.iconCls"></i>{{ item.name }}</template>
                <el-menu-item :index="children.path+''" v-for="(children,indexj) in item.children" :key="indexj">
                  {{ children.name }}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </el-aside>
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right" v-if="this.$router.currentRoute.path!='/home'">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{ this.$router.currentRoute.name }}</el-breadcrumb-item>
          </el-breadcrumb>
          <div v-if="this.$router.currentRoute.path==='/home'">
<!--            <MyFiles></MyFiles>-->
          </div>
          <router-view class="homeRouterView"/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      user: JSON.parse(window.sessionStorage.getItem('user'))
    }
  },
  mounted() {
    this.show = true
  },
  computed: {
    routes() {
      return this.$store.state.routes
    }
    // user () {
    //   return this.$store.state.currentUser
    // }
  },
  methods: {
    commandHandler(command) {
      if (command === 'logout') {
        this.$confirm('此操作将注销登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 注销登录
          this.postRequest('/logout')
          // 清空用户信息
          window.sessionStorage.removeItem('tokenStr')
          window.sessionStorage.removeItem('user')
          // 清空菜单
          this.$store.commit('initRoutes', [])
          // 跳转到登录页面
          this.$router.replace('/login')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
      if (command === 'userInfo') {
        this.$router.push('/userInfo')
      }
    }
  }
}
</script>

<style scoped>
.homeHeader {
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  border-bottom: 3px solid #eaeaea;
}

.leftMsg {
  display: flex;
  align-items: center;
}

.logoImg {
  /*width: 357px;*/
  /*height: 62px;*/
  /*margin-top: 16px;*/
  width: 40px;
  height: 40px;
  float: left;
}

.title {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  float: left;
  padding-left: 5px;
  flex-direction: column; /* 按照列column(垂直方向)排列*/
  margin-left: 10px;
}

.sysName {
  color: #303133;
  font-size: 18px;
}

.fileSize {
  color: #C0C4CC;
  font-size: 14px;
  /*padding-top: 10px;*/
}

.userInfo {

  cursor: pointer;
  font-size: 16px;
  display: flex;
  margin-right: 10px;
}

.homeRouterView {
  margin-top: 10px;
}
</style>
